class NilayaTheme {
  constructor(){
    this.drawer=document.querySelector('[data-cart-drawer]');
    this.header=document.querySelector('.site-header');
    this.mobileMenu=document.querySelector('[data-mobile-menu]');
    this.initProductGallery();
    this.initPhotoUpload();
    this.bind();
    this.initRevealAnimations();
    this.initReviewSliders();
    this.initCharCounters();
    this.initLightbox();
    this.initNavDropdowns();
    this.initCollectionFilters();
    this.handleScroll();
    const progress=this.drawer.querySelector('[data-cart-quantity-progress]');
    if(progress){
      const message=progress.querySelector('[data-cart-quantity-message]');
      const bar=progress.querySelector('[data-cart-quantity-bar]');
      let text='';
      let width=0;
      if(cart.item_count < 2){
        text=`Ajoutez encore ${2-cart.item_count} bijou pour profiter de -10 %.`;
        width=cart.item_count*25;
      }else if(cart.item_count < 3){
        text='🎉 -10 % débloqués - encore 1 bijou pour passer à -15 %.';
        width=50;
      }else if(cart.item_count < 4){
        text='🎉 -15 % débloqués - encore 1 bijou pour passer à -20 %.';
        width=75;
      }else{
        text='🎉 -20 % débloqués sur votre sélection.';
        width=100;
      }
      if(message) message.textContent=text;
      if(bar) bar.style.width=`${width}%`;
    }
    this.updateCartCountDisplay();
  }

  bind(){
    this.bindProductForms();

    document.addEventListener('click',(e)=>{
      const open=e.target.closest('[data-cart-open]');
      const close=e.target.closest('[data-cart-close]');
      const mobile=e.target.closest('[data-mobile-toggle]');
      const insideMenu=e.target.closest('[data-mobile-menu]');
      const qtyBtn=e.target.closest('[data-qty-change]');
      const removeBtn=e.target.closest('[data-cart-remove]');

      if(open){
        e.preventDefault();
        this.openCart();
        return;
      }

      if(close){
        e.preventDefault();
        this.closeCart();
        return;
      }

      if(qtyBtn){
        e.preventDefault();
        const line=qtyBtn.closest('[data-cart-line]');
        if(!line) return;
        const key=line.dataset.key;
        const current=parseInt(line.dataset.quantity||'1',10);
        const delta=parseInt(qtyBtn.dataset.qtyChange,10);
        this.changeCartLine(key, Math.max(0,current+delta));
        return;
      }

      if(removeBtn){
        e.preventDefault();
        const line=removeBtn.closest('[data-cart-line]');
        if(!line) return;
        this.changeCartLine(line.dataset.key, 0);
        return;
      }

      if(mobile){
        e.preventDefault();
        const isOpen=this.mobileMenu?.classList.toggle('is-open');
        mobile.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        return;
      }

      if(this.mobileMenu?.classList.contains('is-open') && !insideMenu){
        this.mobileMenu.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown',(e)=>{
      if(e.key==='Escape'){
        this.closeCart();
        this.mobileMenu?.classList.remove('is-open');
      }
    });

    window.addEventListener('scroll',()=>this.handleScroll(),{passive:true});

    document.addEventListener('submit',async(e)=>{
      const form=e.target.closest('[data-quick-add], [data-product-form]');
      if(!form) return;
      e.preventDefault();
      const btn=form.querySelector('button[type="submit"]');
      const old=btn?.textContent;
      if(btn){btn.disabled=true;btn.textContent='Ajout…';}
      try{
        const endpoint=(window.Shopify?.routes?.root || '/')+'cart/add.js';
        const res=await fetch(endpoint,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!res.ok){
          const err=await res.json().catch(()=>null);
          throw new Error(err?.description || 'Cart error');
        }
        await this.refreshCart();
        this.openCart();
      }catch(err){
        if(btn){btn.textContent=old;}
        window.alert(err.message || "Impossible d'ajouter cet article au panier.");
      }finally{
        if(btn){btn.disabled=false; if(btn.textContent==='Ajout…') btn.textContent=old;}
      }
    });
  }

  bindProductForms(){
    document.querySelectorAll('[data-product-form]').forEach(form=>{
      const variantsNode=form.querySelector('[data-product-variants]');
      const idInput=form.querySelector('[data-variant-id]');
      if(!variantsNode||!idInput) return;
      let variants=[];
      try{variants=JSON.parse(variantsNode.textContent);}catch(e){return;}

      const section=form.closest('.main-product');
      const priceWrap=section?.querySelector('[data-product-price]');
      const priceEl=priceWrap?.querySelector('[data-price]');
      const compareEl=priceWrap?.querySelector('[data-compare-price]');
      const discountEl=priceWrap?.querySelector('[data-discount-badge]');

      const money=(cents)=>this.money(cents);

      const sync=()=>{
        const selected=[...form.querySelectorAll('[data-option-index]')].map(el=>el.value);
        const variant=selected.length
          ? variants.find(v=>v.options.every((opt,i)=>opt===selected[i]))
          : variants[0];
        const submit=form.querySelector('[data-product-submit]');
        if(!variant) return;

        idInput.value=variant.id;
        const mediaNode=form.querySelector('[data-variant-media]');
        if(mediaNode){try{const mediaMap=JSON.parse(mediaNode.textContent);if(mediaMap[variant.id]) this.showGalleryMedia(mediaMap[variant.id]);}catch(e){}}
        const variantUrl=new URL(window.location.href);variantUrl.searchParams.set('variant',variant.id);window.history.replaceState({},'',variantUrl);

        if(submit){
          submit.disabled=!variant.available;
          submit.textContent=variant.available?'Ajouter au panier':'Épuisé';
        }

        if(priceEl) priceEl.textContent=money(variant.price);

        if(variant.compare_at_price && variant.compare_at_price > variant.price){
          if(compareEl){ compareEl.textContent=money(variant.compare_at_price); compareEl.hidden=false; }
          if(discountEl){
            const pct=Math.round(((variant.compare_at_price - variant.price)/variant.compare_at_price)*100);
            discountEl.textContent=`-${pct} %`;
            discountEl.hidden=false;
          }
        }else{
          if(compareEl) compareEl.hidden=true;
          if(discountEl) discountEl.hidden=true;
        }
      };

      form.querySelectorAll('[data-option-index]').forEach(el=>el.addEventListener('change',sync));
      sync();
    });
  }

  showGalleryMedia(id){
    document.querySelectorAll('[data-gallery-media]').forEach(el=>{el.hidden=el.dataset.galleryMedia!==String(id);});
    document.querySelectorAll('[data-gallery-select]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.gallerySelect===String(id))));
  }

  initProductGallery(){
    document.querySelectorAll('[data-gallery-select]').forEach(button=>button.addEventListener('click',()=>this.showGalleryMedia(button.dataset.gallerySelect)));
  }

  initPhotoUpload(){
    document.querySelectorAll('[data-photo-upload]').forEach(input=>{
      let previewUrl=null;
      input.addEventListener('change',()=>{
        const file=input.files?.[0];
        const preview=input.closest('.property-field')?.querySelector('[data-photo-preview]');
        if(previewUrl){URL.revokeObjectURL(previewUrl);previewUrl=null;}
        if(preview){preview.hidden=true;preview.removeAttribute('src');}
        input.setCustomValidity('');
        if(!file) return;
        if(file.size>10*1024*1024){input.setCustomValidity(input.dataset.sizeError);input.reportValidity();return;}
        if(preview && ['image/jpeg','image/png'].includes(file.type)){
          previewUrl=URL.createObjectURL(file);preview.src=previewUrl;preview.hidden=false;
        }
      });
    });
  }

  initCharCounters(){
    document.querySelectorAll('[data-char-counter]').forEach(input=>{
      const display=input.closest('.property-field')?.querySelector('[data-char-counter-display]');
      if(!display) return;
      const max=parseInt(input.getAttribute('maxlength')||'0',10) || null;
      const update=()=>{
        const len=input.value.length;
        display.textContent = max ? `${len} / ${max} caractères` : `${len} caractères`;
        display.classList.toggle('is-limit', max ? len>=max : false);
      };
      input.addEventListener('input',update);
      update();
    });
  }

  initLightbox(){
    const lightbox=document.querySelector('[data-lightbox]');
    const triggers=Array.from(document.querySelectorAll('[data-lightbox-trigger]'));
    if(!lightbox || !triggers.length) return;
    const img=lightbox.querySelector('[data-lightbox-img]');
    let index=0;
    const show=(i)=>{
      index=(i+triggers.length)%triggers.length;
      const t=triggers[index];
      img.src=t.getAttribute('data-full-src');
      img.alt=t.querySelector('img')?.alt || '';
    };
    const open=(i)=>{ show(i); lightbox.hidden=false; document.body.style.overflow='hidden'; };
    const close=()=>{ lightbox.hidden=true; document.body.style.overflow=''; };
    triggers.forEach((t,i)=>t.addEventListener('click',()=>open(i)));
    lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click',close);
    lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click',()=>show(index-1));
    lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click',()=>show(index+1));
    lightbox.addEventListener('click',(e)=>{ if(e.target===lightbox) close(); });
    document.addEventListener('keydown',(e)=>{
      if(lightbox.hidden) return;
      if(e.key==='Escape') close();
      if(e.key==='ArrowLeft') show(index-1);
      if(e.key==='ArrowRight') show(index+1);
    });
  }

  initNavDropdowns(){
    const items=Array.from(document.querySelectorAll('.header-nav__item.has-children'));
    if(!items.length) return;
    items.forEach(item=>{
      const trigger=item.querySelector(':scope > a');
      if(!trigger) return;
      const setExpanded=(val)=>trigger.setAttribute('aria-expanded', val ? 'true' : 'false');
      item.addEventListener('mouseenter',()=>setExpanded(true));
      item.addEventListener('mouseleave',()=>setExpanded(false));
      item.addEventListener('focusin',()=>setExpanded(true));
      item.addEventListener('focusout',(e)=>{ if(!item.contains(e.relatedTarget)) setExpanded(false); });
    });
    document.addEventListener('keydown',(e)=>{
      if(e.key!=='Escape') return;
      const open=items.find(item=>item.matches(':hover, :focus-within'));
      if(!open) return;
      if(document.activeElement && open.contains(document.activeElement)) document.activeElement.blur();
      open.querySelector(':scope > a')?.setAttribute('aria-expanded','false');
    });
  }

  initRevealAnimations(){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const selectors=[
      '.section-heading',
      '.hero__content-inner',
      '.category-card',
      '.gift-card',
      '.product-card',
      '.benefit',
      '.testimonial',
      '.gallery__item',
      '.editorial-split',
      '.newsletter-box'
    ];
    const elements=document.querySelectorAll(selectors.join(','));
    if(!elements.length) return;
    const observer=new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.classList.add('will-reveal','is-visible');
          observer.unobserve(entry.target);
        }
      });
    },{threshold:.12, rootMargin:'0px 0px -40px 0px'});
    elements.forEach((el,index)=>{
      el.classList.add('will-reveal');
      el.style.transitionDelay=`${Math.min(index % 6,5) * 60}ms`;
      observer.observe(el);
    });
  }


  initCollectionFilters(){
    const toggle=document.querySelector('[data-filters-toggle]');
    const panel=document.querySelector('[data-filters-panel]');
    if(toggle && panel){
      toggle.addEventListener('click',()=>{
        const isOpen=panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
    document.querySelectorAll('[data-filters-close]').forEach(btn=>{
      btn.addEventListener('click',()=>panel?.classList.remove('is-open'));
    });
    document.querySelectorAll('[data-filter-input]').forEach(input=>{
      input.addEventListener('change',()=>{
        const form=input.closest('form');
        form?.requestSubmit ? form.requestSubmit() : form?.submit();
      });
    });
  }

  initReviewSliders(){
    document.querySelectorAll('[data-review-slider]').forEach(slider=>{
      const section=slider.closest('.testimonial-section');
      const prev=section?.querySelector('[data-slider-prev]');
      const next=section?.querySelector('[data-slider-next]');
      const amount=()=>Math.max(slider.clientWidth*.82,280);
      prev?.addEventListener('click',()=>slider.scrollBy({left:-amount(),behavior:'smooth'}));
      next?.addEventListener('click',()=>slider.scrollBy({left:amount(),behavior:'smooth'}));
    });
  }

  handleScroll(){
    if(!this.header) return;
    this.header.classList.toggle('is-scrolled', window.scrollY > 10);
  }

  openCart(){
    this.cartReturnFocus=document.activeElement;
    this.drawer?.classList.add('is-open');
    this.drawer?.setAttribute('aria-hidden','false');
    this.drawer?.querySelector('[data-cart-close][type="button"]')?.focus();
    document.documentElement.style.overflow='hidden';
  }

  closeCart(){
    const wasOpen=this.drawer?.classList.contains('is-open');
    this.drawer?.classList.remove('is-open');
    this.drawer?.setAttribute('aria-hidden','true');
    if(wasOpen) this.cartReturnFocus?.focus();
    document.documentElement.style.overflow='';
  }

  async changeCartLine(key, quantity){
    const root=window.Shopify?.routes?.root || '/';
    await fetch(root+'cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key, quantity})
    });
    await this.refreshCart();
  }

  async refreshCart(){
    if(!this.drawer) return;
    const root=window.Shopify?.routes?.root || '/';
    const cart=await fetch(root+'cart.js').then(r=>r.json());
    const count=document.querySelector('[data-cart-count]');
    if(count){
      count.textContent=cart.item_count;
      count.hidden=cart.item_count < 1;
    }
    const items=this.drawer.querySelector('[data-cart-items]');
    const subtotal=this.drawer.querySelector('[data-cart-subtotal]');
    if(subtotal) subtotal.textContent=this.money(cart.total_price);
    const footer=this.drawer.querySelector('[data-cart-footer]');
    if(footer) footer.hidden = cart.items.length === 0;
    if(items){
      if(!cart.items.length){
        items.innerHTML='<p style="padding:24px 0">Votre panier est vide.</p>';
      }else{
        items.innerHTML=cart.items.map(i=>{
          const props=Object.entries(i.properties||{}).filter(([k,v])=>v && k[0]!=='_');
          const propsHtml=props.length
            ? `<dl class="drawer-line__properties">${props.map(([k,v])=>`<div><dt>${this.escape(k)}</dt><dd>${this.escape(v)}</dd></div>`).join('')}</dl>`
            : '';
          return `<div class="drawer-line" data-cart-line data-key="${i.key}" data-quantity="${i.quantity}">
            ${i.image?`<img src="${i.image}" alt="">`:''}
            <div>
              <strong>${this.escape(i.product_title)}</strong>
              ${i.variant_title&&i.variant_title!=='Default Title'?`<div style="font-size:.8rem;color:#746c64">${this.escape(i.variant_title)}</div>`:''}
              ${propsHtml}
              <div class="drawer-line__controls">
                <div class="drawer-line__qty">
                  <button type="button" data-qty-change="-1" aria-label="Diminuer la quantité">−</button>
                  <span>${i.quantity}</span>
                  <button type="button" data-qty-change="1" aria-label="Augmenter la quantité">+</button>
                </div>
                <button type="button" class="drawer-line__remove" data-cart-remove>Supprimer</button>
              </div>
              <div style="margin-top:6px">${this.money(i.final_line_price)}</div>
            </div>
          </div>`;
        }).join('');
      }
    }
    this.updateCartCountDisplay();
  }

  updateCartCountDisplay(){
    const count=document.querySelector('[data-cart-count]');
    if(!count) return;
    const value=parseInt(count.textContent || '0',10);
    count.hidden = !value;
  }

  money(cents){
    return new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{
      style:'currency',
      currency:window.Shopify?.currency?.active||'EUR'
    }).format(cents/100);
  }

  escape(str){
    return String(str||'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[c]));
  }
}

document.addEventListener('DOMContentLoaded',()=>new NilayaTheme());

document.addEventListener('click',event=>{const trigger=event.target.closest('[data-sticky-product-submit]');if(!trigger)return;const form=document.querySelector('[data-product-form]');if(!form)return;const invalid=[...form.querySelectorAll('[required]')].find(field=>!field.value);if(invalid){event.preventDefault();invalid.scrollIntoView({behavior:'smooth',block:'center'});invalid.focus();return;}form.requestSubmit();});
document.addEventListener('DOMContentLoaded',()=>{const syncPersonalizationCta=()=>{const form=document.querySelector('[data-product-form]');if(!form)return;const required=[...form.querySelectorAll('[required]')];if(!required.length)return;const ready=required.every(field=>field.value);const label=ready?'Commander mon bijou':'Personnaliser mon bijou';form.querySelectorAll('[data-product-submit]').forEach(button=>button.textContent=label);document.querySelectorAll('[data-sticky-product-submit]').forEach(button=>button.textContent=label);};document.addEventListener('input',syncPersonalizationCta);document.addEventListener('change',syncPersonalizationCta);syncPersonalizationCta();});
